"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var FormatoMilesFilter = function FormatoMilesFilter() {
    return function (number) {
        if (number == null || isNaN(number)) return number;
        number = Math.round(Number(number)).toString();
        return number.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };
};

exports.default = FormatoMilesFilter;


// WEBPACK FOOTER //
// ./src/busqueda/filtros/formatomiles.filter.js